enum TooltipEditorModes {
    Basic = 'Tooltips',
    AddTooltipCoords = 'Add Tooltip Coords',
    AddTooltipSizes = 'Add Tooltip Sizes',
    DeleteTooltip = 'Delete Tooltip',
}

enum TooltipContentPlacement {
    Left = 'left',
    Right = 'right',
    Top = 'top',
    Bottom = 'bottom',
}

enum TooltipContentPlacementInUrl {
    Left = 'l',
    Right = 'r',
    Top = 't',
    Bottom = 'b',
}

enum TooltipTwoLinesSizesPlacementType {
    Horizontal = 'Horizontal',
    Vertical = 'Vertical',
}

enum TooltipTwoLinesSizesPlacementInURLType {
    Horizontal = 'h',
    Vertical = 'v',
}

enum TooltipSizeVariantType {
    Dot = 'Dot',
    TwoLines = 'TwoLines',
}

enum TooltipSizeVariantInURLType {
    Dot = 'd',
    TwoLines = 'tL',
}

type TooltipCordType = {
    x: number;
    y: number;
};

type TooltipCordInURLType = [number, number];

type TooltipCoordsType = Map<number, TooltipCordType>;

type TooltipInURLCoordsType = [number, number, number][];

type TooltipSizeLineCoordsType = [TooltipCordType, TooltipCordType];

type TooltipTwoLinesSizeTextType = {
    text: string;
    footnoteStartPointCord?: TooltipCordType;
};

type TooltipFootnoteSizeTextType = {
    top?: string;
    bottom?: string;
};

type TooltipTwoLinesSizeType = {
    variant: TooltipSizeVariantType.TwoLines;
    pointCoords: [TooltipCordType, TooltipCordType];
    sizeDisplayCoords: TooltipCordType;
    position: TooltipTwoLinesSizesPlacementType;
    text: TooltipTwoLinesSizeTextType;
};

type TooltipTwoLinesSizeInURLType = [
    TooltipSizeVariantInURLType,
    [TooltipCordInURLType, TooltipCordInURLType],
    TooltipCordInURLType,
    TooltipTwoLinesSizesPlacementInURLType,
    [string, TooltipCordInURLType?],
];

type TooltipDotSizeType = {
    variant: TooltipSizeVariantType.Dot;
    objectCoords: TooltipCordType;
    sizeDisplayCoords: TooltipCordType;
    text: TooltipFootnoteSizeTextType;
};

type TooltipDotSizeInURLType = [
    TooltipSizeVariantInURLType,
    TooltipCordInURLType,
    TooltipCordInURLType,
    [string, string],
];

type TooltipSizeType = TooltipTwoLinesSizeType | TooltipDotSizeType;

type TooltipInURLSizeType = TooltipTwoLinesSizeInURLType | TooltipDotSizeInURLType;

type TooltipSizesType = {
    frameIndex: number;
    sizes: TooltipSizeType[];
};

type TooltipSizesInURLType = [number, TooltipInURLSizeType[]];

type TooltipType = {
    text: string;
    coords: TooltipCoordsType;
    contentPlacement?: TooltipContentPlacement;
    sizes?: TooltipSizesType;
};

type TooltipInURLType = [
    string,
    TooltipInURLCoordsType,
    TooltipSizesInURLType,
    TooltipContentPlacementInUrl?,
];
type TooltipsType = TooltipType[];

type TooltipsQueryParamType = [TooltipInURLType[], boolean, boolean];

type OnAddTooltipCordType = (coords: TooltipCoordsType) => void;

export type {
    TooltipsQueryParamType,
    TooltipInURLCoordsType,
    TooltipSizesInURLType,
    TooltipInURLSizeType,
    TooltipInURLType,
    TooltipCordType,
    TooltipCoordsType,
    TooltipTwoLinesSizeType,
    TooltipDotSizeType,
    TooltipTwoLinesSizeInURLType,
    TooltipDotSizeInURLType,
    TooltipSizeLineCoordsType,
    TooltipTwoLinesSizeTextType,
    TooltipFootnoteSizeTextType,
    TooltipSizeType,
    TooltipSizesType,
    TooltipType,
    TooltipsType,
    OnAddTooltipCordType,
};
export {
    TooltipEditorModes,
    TooltipContentPlacement,
    TooltipContentPlacementInUrl,
    TooltipTwoLinesSizesPlacementType,
    TooltipTwoLinesSizesPlacementInURLType,
    TooltipSizeVariantType,
    TooltipSizeVariantInURLType,
};
